window.addEventListener('DOMContentLoaded', () => {
	// get all inputs that use the added 'floating' class
	const inputs = document.querySelectorAll<HTMLInputElement>('.plauditQueryLoopField__floatingLabel input');
	// if there are query params, add the floating fields
	if (new URL(window.location.href).searchParams.size > 0) {
		for (const input of inputs) {
			input.classList.add('has-focus');
			input.classList.add('is-floating');
			input.closest('.fieldArea')?.querySelector('label')?.classList.toggle('is-floating', true);
		}
	}

	if (inputs.length > 0) {
		for (const input of inputs) {
			// Make the label float when the field is focused
			input.addEventListener('focus', () => {
				input.classList.add('has-focus');
				input.classList.add('is-floating');
				input.closest('.fieldArea')?.querySelector('label')?.classList.toggle('is-floating', true);
			});

			// Move the label back on blur, but only if the field is empty
			input.addEventListener('blur', () => {
				input.classList.remove('has-focus');
				input.classList.remove('is-floating');

				if (input.value === '') {
					input.closest('.fieldArea')?.querySelector('label')?.classList.remove('is-floating');
				}
			});
		}
	}
});
